export const applyRichTextFormatting = (text: string | null | undefined): string => {
  if (!text) return "";
  let formatted = String(text);
  
  formatted = formatted.replace(/<br\s*\/?>/gi, "\n");
  
  formatted = formatted.replace(/<ul>/gi, "\n").replace(/<\/ul>/gi, "\n");
  formatted = formatted.replace(/<ol>/gi, "\n").replace(/<\/ol>/gi, "\n");
  formatted = formatted.replace(/<li>(.*?)<\/li>/gi, "• $1\n");
  
  formatted = formatted.replace(/\n{3,}/g, "\n\n");
  
  // Strip Markdown bold/italic but keep the text
  formatted = formatted.replace(/\*\*(.*?)\*\*/g, "$1");
  formatted = formatted.replace(/__(.*?)__/g, "$1");
  formatted = formatted.replace(/<b>(.*?)<\/b>/gi, "$1");
  formatted = formatted.replace(/<strong>(.*?)<\/strong>/gi, "$1");

  formatted = formatted.replace(/\*(.*?)\*/g, "$1");
  formatted = formatted.replace(/_(.*?)_/g, "$1");
  formatted = formatted.replace(/<i>(.*?)<\/i>/gi, "$1");
  formatted = formatted.replace(/<em>(.*?)<\/em>/gi, "$1");

  formatted = formatted.replace(/<[^>]*>/g, "");
  
  return formatted.trim();
};
